let safeAudioContext = null;

export const getSafeAudioContext = () => {
	if (!safeAudioContext) {
		safeAudioContext = new AudioContext({
			sampleRate: 48000,
			latencyHint: 'interactive',
		});
	}

	return safeAudioContext;
};

export const stereoToMono = (sourceNode, audioContext = getSafeAudioContext()) => {
	const merger = audioContext.createChannelMerger(2);
	sourceNode.connect(merger, 0, 0);
	sourceNode.connect(merger, 0, 1);
	return merger;
};

export const createSilence = ({ audioContext = getSafeAudioContext() }) => {
	const osc = audioContext.createOscillator();
	osc.type = 'sine';
	osc.frequency.value = 0;
	osc.start();

	return osc;
};

/**
 * Converts sourceNode into mono, and adds a base silence to it.
 * @param {*} sourceNode
 * @param {*} audioContext
 * @returns
 */
export const convertToMonoWithSilence = (sourceNode, audioContext = getSafeAudioContext()) => {
	const gain = new GainNode(audioContext, {
		channelCount: 1,
		channelCountMode: 'explicit',
	});
	const monoSourceNode = stereoToMono(sourceNode, audioContext);
	const silence = createSilence({ audioContext });
	silence.connect(gain);
	monoSourceNode.connect(gain);
	return monoSourceNode;
};
